import { useQuery } from '@apollo/client/react';
import QUERIES from 'services/gqlQueries';

type ConfigurationType = {
  name: string;
  value: string;
  type: string;
};

const useConfiguration = <T = string | boolean>(name: string): T | undefined => {
  const { data } = useQuery<{ items: ConfigurationType[] }>(QUERIES.getConfigurations);
  const configuration = data?.items?.find((config: ConfigurationType) => config.name === name);
  if (!configuration) {
    return undefined;
  }
  if (configuration.type === 'BOOLEAN') {
    return (configuration.value.toLowerCase() === 'true') as T;
  }
  return configuration.value as T;
};

export default useConfiguration;
